const WEEKDAY_KEYS = [
  'common.weekdays.monday',
  'common.weekdays.tuesday',
  'common.weekdays.wednesday',
  'common.weekdays.thursday',
  'common.weekdays.friday',
  'common.weekdays.saturday',
  'common.weekdays.sunday',
] as const

/** ISO-8601 weekday (1 = Monday … 7 = Sunday) to a catalog weekday key. */
export function weekdayKey(weekday: number | null | undefined): string | null {
  if (weekday == null || !Number.isInteger(weekday)) return null
  if (weekday < 1 || weekday > WEEKDAY_KEYS.length) return null
  return WEEKDAY_KEYS[weekday - 1]
}

/**
 * Upstream `Activity.recurrenceLabel`: “Ogni lunedì”. Returns null when the
 * backend has no weekday, so callers can omit the chip instead of guessing.
 */
export function recurrenceLabel(
  weekday: number | null | undefined,
  t: (key: string, options?: Record<string, unknown>) => string,
): string | null {
  const key = weekdayKey(weekday)
  if (!key) return null
  return t('common.everyWeekday', { weekday: t(key) })
}

/** Local start time’s ISO weekday, used by the create-form helper copy. */
export function localWeekday(startAt: string): number | null {
  if (!startAt) return null
  const date = new Date(startAt)
  if (Number.isNaN(date.getTime())) return null
  const weekday = date.getDay()
  return weekday === 0 ? 7 : weekday
}
